( function () {
	'use strict';
	/* eslint complexity:0 */

	function startFrom () {
		// We already have a limitTo filter built-in to angular,
		// let's make a startFrom filter
		return function ( input, start ) {
			start = parseInt( start, 10 );
			return input.slice( start );
		};
	}

	function searchList ( moment, _ ) {
		var self = this;

		self.checkDate = function ( row, dateType, startDate, endDate ) {
			if ( dateType === 'Started' ) {
				return self.checkStartDate( row, startDate, endDate );
			}

			if ( dateType === 'Submitted' ) {
				return self.checkSubmittedDate( row, startDate, endDate );
			}
		};

		// return true or false
		// TODO: consider timezone
		self.checkStartDate = function ( row, startDate, endDate ) {
			if ( row.startDate ) {
				var rowTime   = moment( row.startDate );
				// set startDate to 0:0:0 of startDate
				var startTime = moment( startDate ).hour( 0 ).minutes( 0 ).seconds( 0 );
				// set endDate to 11:59:59 of endDate.
				var endTime   = moment( endDate ).hour( 23 ).minutes( 59 ).seconds( 59 );

				if ( rowTime.valueOf() >= startTime.valueOf() && rowTime.valueOf() <= endTime.valueOf() ) {
					return true;
				}
			}

			// if not yet returned, return false
			return false;
		};

		// return true or false
		// TODO: consider timezone
		self.checkSubmittedDate = function ( row, startDate, endDate ) {
			if ( row.submitDate ) {
				var rowTime   = moment( row.submitDate );
				var startTime = moment( startDate ).hour( 0 ).minutes( 0 ).seconds( 0 );
				var endTime   = moment( endDate ).hour( 23 ).minutes( 59 ).seconds( 59 );

				if ( rowTime.valueOf() >= startTime.valueOf() && rowTime.valueOf() <= endTime.valueOf() ) {
					return true;
				}
			}

			// if not yet returned, return false
			return false;
		};

		return function ( input, observations, searchText, searchFilter, dateType, startDate, endDate ) {
			var list = [ ];

			if ( angular.isUndefined( searchText ) ) {
				searchText = '';
			} else {
				searchText = _.escapeRegExp( searchText.toString() );
			}

			var pattern = new RegExp( searchText, 'gi' );

			var templateTest = false;

			angular.forEach( observations, function ( row ) {
				if ( row.template.name ) {
					templateTest = row.template.name.match( pattern );
				}

				switch ( searchFilter ) {
					case 'Search All':
						if ( ( row.name.match( pattern ) || ( row.observee.firstName + ' ' + row.observee.lastName ).match( pattern ) || ( row.observer.firstName + ' ' + row.observer.lastName ).match( pattern ) || templateTest ) && self.checkDate( row, dateType, startDate, endDate ) ) {
							list.push( row );
						}
						break;

					case 'Title':
						if ( row.name.match( pattern ) && self.checkDate( row, dateType, startDate, endDate ) ) {
							list.push( row );
						}
						break;

					case 'Invitee':
						if ( ( row.observee.firstName + ' ' + row.observee.lastName ).match( pattern ) && self.checkDate( row, dateType, startDate, endDate ) ) {
							list.push( row );
						}
						break;

					case 'Observer':
						if ( ( row.observer.firstName + ' ' + row.observer.lastName ).match( pattern ) && self.checkDate( row, dateType, startDate, endDate ) ) {
							list.push( row );
						}
						break;

					case 'Template':
						if ( templateTest && self.checkDate( row, dateType, startDate, endDate ) ) {
							list.push( row );
						}
						break;

					default: {
						if ( ( row.name.match( pattern ) || ( row.observee.firstName + ' ' + row.observee.lastName ).match( pattern ) || ( row.observer.firstName + ' ' + row.observer.lastName ).match( pattern ) || templateTest ) && self.checkDate( row, dateType, startDate, endDate ) ) {
							list.push( row );
						}
						break;
					}
				}
			} );

			return list;
		};
	}

	searchList.$inject = [ 'moment', '_' ];

	angular
		.module( 'app.observations' )
		.filter( 'startFrom', startFrom )
		.filter( 'searchList', searchList );
} )();
